// Helper function to pass axios error responses to our error handling callbacks
const displayBackendErrors = (
  error,
  setFieldErrorCallback,
  setNonFieldErrorCallback,
  formControls,
) => {
  const backendErrors = error.response?.data;
  if (backendErrors) {
    // PressReleaseSerializer contains fields that are not explicitly
    // fields on the form (Ex: press_contacts, multimedia_add_ons), so identify
    // the fields that are on the page.
    const fieldNames = formControls.map((obj) => obj.fieldName);
    // Serializer errors are always returned as dictionary responses
    Object.entries(backendErrors).forEach(([key, value]) => {
      if (fieldNames.includes(key)) {
        setFieldErrorCallback(key, value[0]);
      } else setNonFieldErrorCallback(value);
    });
  } else setNonFieldErrorCallback(error);
};

export default displayBackendErrors;
